import React, {Component} from 'react';
import HeaderComponent
    from "../../../../Components/HeaderComponent/HeaderComponent";
import {Typography} from "@material-ui/core";
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";
import MessageService from "../../../../Services/MessageService";
import MessageUtil from "../../../../Utils/MessageUtil";
import TableHistoryMensageriaComponent from "./TableHistoryMensageriaComponent";
import ModalDetailsHistoryComponent from "./ModalDetailsHistoryComponent";


class HistoryMensageriaScreen extends Component {
    static ROUTE = '/mensageria-historico';

    constructor(props) {
        super(props);

        this.state = {
            inLoad: false,
            messagens: null,
            erros: [],
            history: [],
            pagination: null,
            search: '',
            isDetailsOpen: false,
            selectedDetail: null,
        };

        this.messageService = new MessageService();
    }

    componentDidMount() {
        this.load();
    }

    async load(page = 1, search = this.state.search) {
        try {
            this.setState({
                inLoad: true,
                search: search,
            });

            const response = await this.messageService.getHistoryAdmin({
                page: page,
                search: search,
            });

            this.setState({
                inLoad: false,
                history: response.data.data,
                pagination: response.data.meta,
            });

        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    }

    handleOpenDetails = async (uuid) => {
        try {
            this.setState({ inLoad: true });
            const response = await this.messageService.getDetails(uuid);
            this.setState({
                inLoad: false,
                selectedDetail: response.data.data || response.data,
                isDetailsOpen: true,
            });
        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    };

    render() {
        return (
            <>
                <HeaderComponent title={'Mensageria: Histórico de Envios'}
                                 menu={true}
                                 messagens={this.state?.messagens}
                                 inLoad={this.state.inLoad}/>
                <Typography align={'center'}
                            variant={'h6'}
                            color={'primary'}>
                    Histórico de Envios
                </Typography>
                <SpacerComponent height={20}/>
                <TableHistoryMensageriaComponent
                    history={this.state.history}
                    pagination={this.state.pagination}
                    onChangePage={(page, search) => this.load(page, search)}
                    onOpenDetails={this.handleOpenDetails}
                />
                <ModalDetailsHistoryComponent
                    isOpen={this.state.isDetailsOpen}
                    onClose={() => this.setState({ isDetailsOpen: false })}
                    data={this.state.selectedDetail}
                />
            </>
        );
    }
}

HistoryMensageriaScreen.propTypes = {};

export default HistoryMensageriaScreen;